export default [
  'name',
  'startYear',
  'tags',
  'address',
  'mapCenter',
  'growingZone',
  'isArchived',
  'isLocked',
  'defaultBaseMap',
  'baseLayerRoadsEnabled',
  'baseLayerDarkEnabled',
  'baseLayerContoursEnabled',
] as const;
